import { render, staticRenderFns } from "./opt.vue?vue&type=template&id=0ae54322&scoped=true"
import script from "./opt.vue?vue&type=script&lang=js"
export * from "./opt.vue?vue&type=script&lang=js"
import style0 from "./opt.vue?vue&type=style&index=0&id=0ae54322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae54322",
  null
  
)

export default component.exports